import { graphql } from '../../gql';

export const POSTINGS_V3_GET_DATA = graphql(`
  query PostingsV3Data($req: PostingsV3Req!) {
    postings_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          added {
            id
            val
          }
          removed {
            id
            val
          }
          active {
            id
            val
          }
          time_to_fill {
            id
            val
          }
          salary {
            id
            val
          }
          role_counts {
            id
            rank
            short_name
            long_name
            count
            share
          }
          company_counts {
            id
            rank
            short_name
            long_name
            count
            share
          }
        }
      }
    }
  }
`);

export const POSTINGS_V3_TOOLTIP = graphql(`
  query PostingsV3Tooltip($req: PostingsV3Req!) {
    postings_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          active {
            id
            val
          }
          time_to_fill {
            id
            val
          }
        }
      }
    }
  }
`);
